/* The initial Liquid cart is already fresh. Refresh only restored or invalidated pages. */
(() => {
  if (window.NetlagerCartSync) return;
  let stale = false;
  let scheduled = false;
  function refresh() {
    if (document.visibilityState === 'hidden' || scheduled) return;
    scheduled = true;
    queueMicrotask(() => {
      scheduled = false;
      if (!stale || document.visibilityState === 'hidden') return;
      stale = false;
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true, detail: { scrollToTop: false }
      }));
    });
  }
  window.addEventListener('pageshow', event => {
    if (event.persisted) { stale = true; refresh(); }
  });
  window.addEventListener('storage', event => {
    if (event.key === 'netlager:cart:changed' && event.newValue !== event.oldValue) { stale = true; refresh(); }
  });
  document.addEventListener('visibilitychange', refresh);
  window.NetlagerCartSync = { refresh };
})();
